const extend = require('lodash/extend');

const inject = [
  '$sce',
  '$window',
  '$timeout',
  '$location',
  'paymetricService',
  'apiUrls',
  '$element',
  '$scope',
  '$q',
  '$log'
];

function PaymetricControllerFactory(
  $sce,
  $window,
  $timeout,
  $location,
  paymetricService,
  apiUrls,
  $element,
  $scope,
  $q,
  $log
) {
  class PaymetricController {
    constructor() {
      this.src = $sce.trustAsResourceUrl(`${apiUrls.masterDbUrl}/msi/paymetric/get_html_content?o=${this.origin}`);
      this.iframe = $element.find('iframe');
    }

    get origin() {
      let result = `${$location.protocol()}://${$location.host()}`;
      if ($location.port() !== 80) {
        result += `:${$location.port()}`;
      }

      return result;
    }

    $postLink() {
      this.iframe.bind('load', this.tokenizePayment.bind(this, this.payment));

      $scope.$on('$destroy', () => this.iframe.unbind('load'));
    }

    tokenizePayment(payment) {
      return this.getSignedPaymetricPacket()
        .then(() => this.submitPayment(payment))
        .then(
          (token) => {
            this.onFinished({ result: token });
            return token;
          },
          (err) => {
            const rejected = $q.reject(err);
            this.onFinished({ result: rejected });

            return rejected;
          }
        );
    }

    postMessage(msg) {
      this.iframe[0].contentWindow.postMessage(msg, apiUrls.masterDbUrl);
    }

    getSignedPaymetricPacket() {
      return paymetricService.getSignedPaymetricPacket()
        .then(data => this.initIframe(data))
        .catch((err) => {
          $log.error(err);
          return $q.reject(err);
        })
        .finally(() => this.unbindInit());
    }

    unbindInit() {
      $window.removeEventListener('message', this.initIframeListener);
      this.iframe.unbind('load');
    }

    initIframeListener() {
      return $q((resolve, reject) => {
        const listener = (event) => {
          try {
            const data = angular.fromJson(event.data);
            if (data.command === 'updated') {
              if (data.data === 'error') {
                $scope.$apply(() => reject(new Error('Unable to initialize paymetric iframe.')));
              }
              else {
                $scope.$apply(() => resolve());
              }
            }
          }
          catch (e) {
            $scope.$apply(() => reject(e));
          }
        };
        $window.addEventListener('message', listener);

        const timer = $timeout(() => reject(new Error('Iframe initialization timed out')), 30000);
        $scope.$on('$destroy', () => $timeout.cancel(timer));
      });
    }

    initIframe(packet) {
      const promise = this.initIframeListener();

      this.postMessage(angular.toJson({
        command: 'update',
        data: extend(packet, {
          postMessageUrl: this.origin
        })
      }));

      return promise;
    }

    submitPaymentListner() {
      return $q((resolve, reject) => {
        function listener(e) {
          try {
            const payload = angular.fromJson(e.data);
            const command = payload.command;
            const data = payload.data;
            if (command === 'process_token') {
              $scope.$apply(() => resolve(data.cc_token));
            }
            else if (command === 'error') {
              $scope.$apply(() => reject(data));
            }
          }
          catch (error) {
            $scope.$apply(() => reject(new Error('Paymetric tokenization error')));
          }
        }

        const timer = $timeout(() => reject(new Error('Paymetric tokenization request timed out')), 30000);
        $scope.$on('$destroy', () => $timeout.cancel(timer));

        $window.addEventListener('message', listener.bind(this));
      });
    }

    submitPayment(payment) {
      const promise = this.submitPaymentListner();
      const message = angular.toJson({
        command: 'tokenize',
        data: extend(payment, { originUrl: this.origin })
      });

      this.postMessage(message);

      return promise
        .finally(() => $window.removeEventListener('message', this.tokenResponseListener));
    }
  }

  return new PaymetricController();
}


PaymetricControllerFactory.$inject = inject;

angular.module('msi.paymetric')
  .controller('PaymetricController', PaymetricControllerFactory);

module.exports = PaymetricControllerFactory;
